export const EXPENSE_CATEGORIES = [
  "Bridal Makeup",
  "Bride Hair",
  "Siders Hair",
  "Sider Makeup",
  "Touchup Session",
  "Saree Draping",
  "Pre-Pleating",
  "Travel - Going",
  "Travel - Return",
  "Others",
];

export const EXPENSE_STATUS_STYLES = {
  draft: "bg-[#8B8B8B]/10 text-[#5C5652] border-[#8B8B8B]/30",
  submitted: "bg-[#D4A373]/10 text-[#D4A373] border-[#D4A373]/30",
  approved: "bg-[#7A9E9F]/10 text-[#4f6f70] border-[#7A9E9F]/40",
  rejected: "bg-red-50 text-red-700 border-red-200",
  paid: "bg-[#829384]/15 text-[#5f7061] border-[#829384]/40",
};

export function INR(n, currency = "INR") {
  try {
    return new Intl.NumberFormat("en-IN", { style: "currency", currency, maximumFractionDigits: 0 }).format(n || 0);
  } catch {
    return `${currency} ${n}`;
  }
}
